import React from 'react'
import ReactDom from 'react-dom'
import ReactModal from 'react-modal'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import SingleStep from './components/single-step'
import MultiStep from './components/multi-step'
import RangeMap from './components/range-map'

const roots = {
  'single-step': SingleStep,
  'multi-step': MultiStep,
  'range-map': RangeMap,
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: window.globaljetBookingTranslation,
      },
    },
    lng: document.documentElement.lang,
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false,
    },
  })

export default el => {
  ReactModal.setAppElement(el)

  const Component = roots[el.dataset.reactRoot] || SingleStep
  ReactDom.render(React.createElement(Component, el.dataset), el)
}
